import { IonModal } from "@ionic/react";
import { forwardRef } from "react";

export const ModalSheet = forwardRef<HTMLIonModalElement, React.ComponentProps<typeof IonModal>>(
  (props, ref) => <IonModal ref={ref} handle={false} {...props} />,
);

ModalSheet.displayName = "ModalSheet";
